import { Grid, Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import API from "@unisearch/helpers/api";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import styles from "./guest_form_review.module.scss";
import { getGeoInfo, swalError, swalSuccess } from "@unisearch/helpers";
import { useRouter } from "next/router";
import PhoneInput from "react-phone-input-2";
import Cookies from "js-cookie";

const customStyles = {
  control: (base, state) => ({
    ...base,
    height: "60px",
    boxShadow: state.isFocused
      ? "0px 4px 15px rgba(244, 127, 32, 0.15)"
      : "none",
    borderColor: "#eeeeee",
    "&:hover": { borderColor: "#eeeeee" }, // border style on hover
    borderColor: state.isFocused ? "#F47F20" : "#eeeeee",
    backgroundColor: "#fff",
    fontSize: "13px",
    borderRadius: "8px",
    padding: "0 20px",
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color: state.isSelected ? "#F47F20" : "#B5B5C3",
    backgroundColor: state.isSelected
      ? "#F5F6FC"
      : state.isFocused
      ? "#fff"
      : provided.backgroundColor,
    fontSize: "13px",
    "&:hover": {
      backgroundColor: "#F5F6FC",
      color: "#F47F20",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "guest",
  reviewerName: "",
  reviewerEmail: "",
  reviewComment: "",
  reviewerPhone: "",
  reviewerCountryId: undefined,
};

const GuestFormReview = ({ uniProfileData, setModal, getData }) => {
  const router = useRouter();
  const { asPath } = router;
  const [lastName, setLastName] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [formData, setFormData] = useState(init);
  const [defaultCountryCode, setDefaultCountryCode] = useState("in");
  useEffect(() => {
    setTimeout(() => {
      if (Cookies.get("default_country")) {
        setDefaultCountryCode(Cookies.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]);

  // all country list
  const getCountryList = async () => {
    await API.get("/public/country/dropdown")
      .then((res) => {
        if (!res.error) {
          setCountryList(res.data);
        } else {
          setCountryList([]);
        }
      })
      .catch((error) => {
        setCountryList([]);
      });
  };

  // fetch only country
  useEffect(() => {
    getCountryList();
  }, []);

  // validation schema
  const validationSchema = Yup.object().shape({
    rating: Yup.string().required("Please give rating"),
    reviewerName: Yup.string().required("Field is required"),
    reviewerEmail: Yup.string().required("Field is required"),
    reviewerCountryId: Yup.string().required("Field is required"),
    reviewComment: Yup.string().required("Field is required"),
  });

  const handleSubmitForm = async (values) => {
    const payload = {
      universityId: uniProfileData?.universityId,
      rating: values.rating,
      reviewerType: "guest",
      reviewerName: `${values.reviewerName} ${lastName}`,
      reviewerEmail: values.reviewerEmail,
      reviewComment: values.reviewComment,
      reviewerPhone: values.reviewerPhone,
      reviewerCountryId: values.reviewerCountryId,
    };
    await API.post("/public/university-review", payload).then(async (res) => {
      if (!res.error) {
        swalSuccess("Submitted");
        setModal(false);
        await getData();
        router.push(asPath);
      } else {
        swalError(res?.message, "Sorry");
      }
    });
  };

  return (
    <div className={styles.wrapper}>
      <Formik
        initialValues={formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmitForm(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form className="form">
            <div className={styles.rating_wrapper}>
              <Rating
                sx={{ fontSize: "50px" }}
                value={values.rating}
                name="rating"
                onChange={(event, newValue) => {
                  setFieldValue("rating", newValue);
                }}
              />
              {errors.rating && touched.rating && (
                <div className="invalid-feedback frontend">{errors.rating}</div>
              )}
            </div>
            <Grid container spacing={4}>
              <Grid item md={6} sm={12} xs={12}>
                <div className={styles.input_wrapper}>
                  <label>First Name</label>
                  <input
                    type="text"
                    placeholder="First Name"
                    onChange={(e) => {
                      setFieldValue("reviewerName", e.target.value);
                    }}
                    value={values.reviewerName}
                  />
                </div>
                {errors.reviewerName && touched.reviewerName && (
                  <span className="invalid-feedback frontend">
                    {errors.reviewerName}
                  </span>
                )}
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className={styles.input_wrapper}>
                  <label>Last Name</label>
                  <input
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className={styles.input_wrapper}>
                  <label>Email Address</label>
                  <input
                    type="text"
                    placeholder="Email Address"
                    name="reviewerEmail"
                    onChange={(e) => {
                      setFieldValue("reviewerEmail", e.target.value);
                    }}
                    value={values.reviewerEmail}
                  />
                </div>
                {errors.reviewerEmail && touched.reviewerEmail && (
                  <span className="invalid-feedback frontend">
                    {errors.reviewerEmail}
                  </span>
                )}
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className={styles.input_wrapper}>
                  <label>Phone Number</label>
                  {/* <input
                    type="number"
                    placeholder="Phone Number"
                    name="reviewerPhone"
                    onChange={(e) => {
                      setFieldValue("reviewerPhone", e.target.value);
                    }}
                    value={values.reviewerPhone}
                    onWheel={() => document.activeElement.blur()}
                  /> */}
                  <PhoneInput
                    placeholder="Phone Number"
                    country={defaultCountryCode ?? "in"}
                    countryCodeEditable={false}
                    value={values.phone}
                    onChange={(_value, country, _event, formattedValue) => {
                      setFieldValue("reviewerPhone", formattedValue);
                    }}
                    className={styles.phoneInput}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={styles.input_wrapper}>
                  <label>Country</label>
                  <Select
                    id="reviewerCountryId"
                    name="reviewerCountryId"
                    placeholder="Select Your Country"
                    options={countryList ?? []}
                    multi={false}
                    styles={customStyles}
                    onChange={(item) => {
                      setFieldValue("reviewerCountryId", item.value);
                    }}
                    value={
                      countryList
                        ? countryList.filter(
                            (item) => item.value == values?.reviewerCountryId
                          )
                        : {}
                    }
                  />
                </div>
                {errors.reviewerCountryId && touched.reviewerCountryId && (
                  <span className="invalid-feedback frontend">
                    {errors.reviewerCountryId}
                  </span>
                )}
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className={styles.text_input_wrapper}>
                  <label>Write Your Review</label>
                  <textarea
                    style={{ resize: "vertical" }}
                    name="reviewComment"
                    onChange={(e) => {
                      setFieldValue("reviewComment", e.target.value);
                    }}
                    value={values.reviewComment}
                    type="text"
                    placeholder="Write Here"
                  />
                </div>
                {errors.reviewComment && touched.reviewComment && (
                  <span className="invalid-feedback frontend">
                    {errors.reviewComment}
                  </span>
                )}
              </Grid>
              <Grid item sm={12}>
                <div className={styles.action_btn}>
                  <button
                    onClick={() => handleSubmit}
                    type="submit"
                    className="btn btn-secondary btn-md"
                  >
                    Submit Review
                  </button>
                </div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GuestFormReview;
